/* eslint-disable */
/**
 * Local function-reference proxy.
 *
 * The original export was generated by Convex and required a hosted Convex
 * deployment.  The self-hosted runtime only needs an opaque path that can be
 * sent to /api/rpc (or invoked internally by another server function).
 *
 * api.crm.tickets.list becomes "crm/tickets:list".
 */
function referenceProxy(visibility, parts = []) {
  return new Proxy(function localFunctionReference() {}, {
    get(_target, property) {
      if (property === "__visibility") return visibility;
      if (property === "__rpcPath") {
        const fn = parts.at(-1) ?? "";
        const module = parts.slice(0, -1).join("/");
        return `${module}:${fn}`;
      }
      if (property === "toString") {
        return () => {
          const fn = parts.at(-1) ?? "";
          const module = parts.slice(0, -1).join("/");
          return `${module}:${fn}`;
        };
      }
      if (typeof property === "symbol") return undefined;
      return referenceProxy(visibility, [...parts, property]);
    },
  });
}

export const api = referenceProxy("public");
export const internal = referenceProxy("internal");
export const components = {};
